module.exports = __webpack_public_path__ + "img/h1.a0d47449.png";